import styled from "styled-components"

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${props => props.zIndex};
`

export const BiggestContainer = styled.div`
  background-color: #fff;
  border-radius: 5px;
  position: ${({ position }) => position};
  width: ${({ width }) => width || "100%"};
  padding: 0.5rem;
  color: #000;
  box-shadow: ${({ showBoxShadowContainer }) =>
    showBoxShadowContainer ? "1px 1px 5px gray" : "none"};
  border: ${({ showBorderContainer }) => (showBorderContainer ? `1px solid #e9e6e6` : "none")};
  z-index: 10;
  top: ${({ topPosition }) => topPosition};
  left: ${({ leftPosition }) => leftPosition};
  right: ${({ rightPosition }) => rightPosition};
`

export const Container = styled.div`
  flex: 1;
  padding: 0px 0.5rem 0px 0.5rem;
  &::first-letter {
    text-transform: uppercase;
  }
`

export const Content = styled.div`
  display: flex;
  flexdirection: row;
  width: ${({ widthCalendar }) => (widthCalendar ? widthCalendar : "36rem")};
`

export const Title = styled.div`
  font-size: 1.25rem;
  font-weight: bold;
  position: relative;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const ContainerNumber = styled.div`
  padding: 0.5rem 0 0.5rem 0.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
`

export const Number = styled.div`
  width: ${({ isYear }) => (isYear ? "3rem" : "2rem")};
  height: ${({ isYear }) => (isYear ? "3rem" : "2rem")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: ${props => (props.selected ? props.color : props.disabled ? "#E3E3E3" : "#000")};
  margin: 0.25rem;
  cursor: ${props => (props.disabled ? "unset" : "pointer")};
  transition: ${props => (!props.disabled && !props.selected ? "0.3s" : "")};
  background-color: ${({ isDateOfDay, selected, backgroundColor }) => {
    if (selected) return backgroundColor
    if (isDateOfDay) return `${backgroundColor}3F`
  }};
  &:hover {
    background-color: ${props => (!props.disabled && !props.selected ? props.backgroundColor : "")};
    color: ${props => (!props.disabled && !props.selected ? props.color : "")};
    opacity: ${props => (!props.disabled && !props.selected ? 0.5 : "")};
  }
`

export const Arrow = styled.span`
  background-color: #f4f4f4;
  border: 0.2em solid #dedede;
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  font-size: 0.75rem;
  margin: 0 0.15rem;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    opacity: 0.6;
  }
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.85rem;
`

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const CloseBtn = styled.span`
  padding: 0.25rem 0.5rem;
  background-color: #fff;
  color: #fff;
  border: 1px solid ${props => props.color || "green"};
  color: ${props => props.color || "green"};
  border-radius: 0.25rem;
  margin: 1rem 0.5rem 0 0;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background-color: ${props => props.color || "green"};
    color: #fff;
  }
`

export const ValidateBtn = styled.div`
  width: fit-content;
  padding: 0.25rem 1.75rem;
  background-color: ${({ color, disabled }) => (disabled ? "#F4F4F4" : color)};
  color: #fff;
  text-transform: capitalize;
  border-radius: 0.25rem;
  margin-right: 1rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: 0.3s;
  &:hover {
    opacity: 0.6;
  }
`

export const DeleteBtn = styled.div`
  width: fit-content;
  padding: 0.25rem 0.5rem;
  background-color: #fff;
  color: #fff;
  text-transform: capitalize;
  border: 1px solid ${props => props.color || "green"};
  color: ${props => props.color || "green"};
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background-color: ${props => props.color || "green"};
    color: #fff;
  }
`

export const ContainerDatesSelected = styled.div`
  display: flex;
  text-align: center;
  justify-content: space-around;
  padding-bottom: 10px;
`

export const SubContainerDate = styled.div`
  display: flex;
  p:first-child {
    color: ${({ mainColor }) => (mainColor ? mainColor : "red")};
  }
`

export const IconContainers = styled.div`
  display: flex;
  justify-content: space-between;
  width: 250px;
  padding-bottom: 10px;
  margin: auto;
`

export const CloseIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ color }) => (color ? color : "blue")};
  border-radius: 5px;
  position: absolute;
  top: 0px;
  right: 0px;
  margin: 5px;
  cursor: pointer;
  i {
    color: white !important;
  }
  :hover {
    opacity: 0.4;
  }
`
